<template>
  <div class="templatebody" :style="note">
    <div>
      <Userheard></Userheard>
    </div>

    <div class="user-company-container">
      <div class="width-30 user-company-container-img">
        <el-upload
          class="avatar-uploader"
          action="#"
          :limit="1"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-change="handleChange"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p>上传/修改图片</p>
      </div>
      <div
        class=".flex-juspace align-content width-50 user-company-container-text"
      >
        <div class="flex-all-center user-cc-t-margin">
          <div class="user-cc-t-border-left">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">管理员账号：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.admin_account }}</p></el-col
              >
            </el-row>
          </div>
          <div class="user-cc-t-border-right">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">注册时间：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.register_time }}</p></el-col
              >
            </el-row>
          </div>
        </div>
        <div class="flex-all-center" style="margin-top: 2%">
          <div class="user-cc-t-border-left">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">服务商名称：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.company_name }}</p></el-col
              >
            </el-row>
          </div>
          <div class="user-cc-t-border-right">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">续费时间：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.renewal_time }}</p></el-col
              >
            </el-row>
          </div>
        </div>
        <div class="flex-all-center user-cc-t-margin">
          <div class="user-cc-t-border-left">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">注册手机：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.register_mobile_no }}</p></el-col
              >
            </el-row>
          </div>
          <div class="user-cc-t-border-right">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">所在地：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.company_place }}</p></el-col
              >
            </el-row>
          </div>
        </div>
        <div class="flex-all-center" style="margin-top: 2%">
          <div class="user-cc-t-border-left">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">简称：</p></el-col
              >
              <el-col :span="16" class="leftp"><p>{{content.short_name}}</p></el-col>
            </el-row>
          </div>
          <div class="user-cc-t-border-right">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue">到期时间：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.end_time }}</p></el-col
              >
            </el-row>
          </div>
        </div>
        <div class="flex-all-center" style="margin-top: 2%">
          <div class="user-cc-t-border-left">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue" >密码：</p></el-col
              >
              <el-col :span="16" class="leftp" style="line-height:0.18229166666666666rem "><p>***********</p></el-col>
            </el-row>
          </div>
          <div class="user-cc-t-border-right">
            <el-row>
              <el-col :span="8" class="rightp"
                ><p class="text-dackblue" >密钥：</p></el-col
              >
              <el-col :span="16" class="leftp"
                ><p>{{ content.secret }}</p></el-col
              >
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom-text">
      <p>
        版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All
        rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
import "@/assets/css/user.css";
import "@/assets/css/public.css";
import Userheard from "../public/userheard.vue";
import Vue from "vue";
export default {
  components: {
    Userheard,
  },
   inject:['reload'],
  data() {
    return {
      content: {},
      imageUrl: "",
      note: {
        backgroundImage:
          "url(" + require("../../assets/img/bg-login.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
    };
  },
  mounted() {},
  updated() {},
  methods: {
    handleChange(file) {
      
      let fd = new FormData();
      fd.append("logo", file.raw);

      this.http({
        method: "put",
        url: `https://track.freightcloud.net/v1/servicer/info/update?servicer_id=${
          JSON.parse(localStorage.getItem("userInfo")).servicer_id
        }`,
        headers: { token: JSON.parse(localStorage.getItem("userInfo")).token },
        data: fd,
      }).then((res) => {
        console.log(res,1112)
        this.$router.go(0)
       
        
       
      });

    
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    getServerInfo(servicer_id, token) {
     

        this.http.get(`/v1/servicer/info?servicer_id=${servicer_id}`,{headers:{token:token}}).then(res=>{
              console.log(res,33333)
          this.content = res.data.data;
          this.imageUrl = res.data.data.logo;
        })
    },
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let id = userInfo.servicer_id;
    let token = userInfo.token;
    this.getServerInfo(id, token);

  },
};
</script>
<style scoped>
.el-button--primary {
  padding-left: 25px;
  background-color: #fd9405;
  border-color: #fd9405;
}

.el-button--primary:hover {
  background-color: #fd9405;
  border-color: #fd9405;
}

.el-button--primary:focus {
  background-color: #fd9405;
  border-color: #fd9405;
}
.el-form-item__label {
  font-size: 18px;
  color: #ffffff;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 280px;
  line-height: 280px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.templatebody {
  min-height: 95vh;
}
</style>



// WEBPACK FOOTER //
// src/components/user/companyinfor.vue